import angular from "angular";

import BicycleOwnerProfileModuleRouting from "./bicycle-owner-profile.module.routing";

export default angular
  .module("vt-bicycle-owner-profile", [])
  .config(BicycleOwnerProfileModuleRouting);
